import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useBulkPaidInvoicesEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.BulkPaidInvoices, false);

  return Boolean(isEnabled);
}